/* =============================================
   ANBE Madrid - Size Drawer v5
   ============================================= */
(function() {
  'use strict';

  const SOLDOUT_MESSAGE = 'Avísame';
  const SIZE_MESSAGES = {};

  let drawerEl = null;
  let overlayEl = null;
  let currentForm = null;
  let currentSection = null;
  let skipIntercept = false; // bandera para evitar bucle

  function createDrawer() {
    if (document.getElementById('anbe-size-drawer')) return;

    overlayEl = document.createElement('div');
    overlayEl.id = 'anbe-size-overlay';
    overlayEl.addEventListener('click', closeDrawer);
    document.body.appendChild(overlayEl);

    drawerEl = document.createElement('div');
    drawerEl.id = 'anbe-size-drawer';
    drawerEl.innerHTML = `
      <div class="anbe-drawer__header">
        <span class="anbe-drawer__title">Selecciona tu talla</span>
        <button class="anbe-drawer__close" aria-label="Cerrar">&#10005;</button>
      </div>
      <div class="anbe-drawer__subtitle" id="anbe-drawer-subtitle"></div>
      <div class="anbe-drawer__sizes" id="anbe-drawer-sizes"></div>
      <div class="anbe-drawer__footer">
        <a class="anbe-drawer__guide" href="#">Ver guía de tallas</a>
      </div>
    `;
    document.body.appendChild(drawerEl);
    drawerEl.querySelector('.anbe-drawer__close').addEventListener('click', closeDrawer);
    drawerEl.querySelector('.anbe-drawer__guide').addEventListener('click', function(e) {
  e.preventDefault();
  closeDrawer();
  setTimeout(() => {
    const trigger = document.querySelector('.ccpops-trigger');
    if (trigger) trigger.click();
  }, 350);
});
  }
  function updateSizeRecommendation() {
  const rec = document.getElementById('anbe-size-rec');
  const subtitle = document.getElementById('anbe-drawer-subtitle');
  if (!subtitle) return;
  if (rec && rec.dataset.message) {
    subtitle.textContent = rec.dataset.message;
    subtitle.style.display = 'block';
  } else {
    subtitle.style.display = 'none';
  }
}

  function openDrawer(form, section) {
    currentForm = form;
    currentSection = section;
    populateSizes(section);
    updateSizeRecommendation();
    drawerEl.classList.add('is-open');
    overlayEl.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    if (!drawerEl) return;
    drawerEl.classList.remove('is-open');
    overlayEl.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function populateSizes(section) {
    const container = document.getElementById('anbe-drawer-sizes');
    container.innerHTML = '';

    const nodes = section.querySelectorAll('.m-product-option--node[data-option-type="button"]');
    if (!nodes.length) return;

    nodes.forEach(node => {
      const value = node.dataset.value;
      const isSoldOut = node.classList.contains('m-product-option--node__soldout');
      const message = isSoldOut ? SOLDOUT_MESSAGE : (SIZE_MESSAGES[value] || '');

      const row = document.createElement('div');
      row.className = 'anbe-size-row' + (isSoldOut ? ' is-soldout' : '');
      row.innerHTML = `
        <span class="anbe-size-row__name">${value}</span>
        <span class="anbe-size-row__msg">${message}</span>
      `;

      if (!isSoldOut) {
        row.addEventListener('click', () => selectAndAdd(node));
      } else {
        row.addEventListener('click', () => handleSoldOut(value));
      }

      container.appendChild(row);
    });
  }

  function selectAndAdd(node) {
    const radio = node.querySelector('input[type="radio"]');
    const label = node.querySelector('label');

    // Mostrar selector nativo temporalmente
    const optionBtns = currentSection.querySelectorAll('.m-product-option--button, .m-product-option--label');
    optionBtns.forEach(el => el.style.cssText = 'position:absolute;opacity:0;pointer-events:none;height:0;overflow:hidden;');

    // Seleccionar variante
    if (radio) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (label) label.click();

    // Esperar a Alpine, cerrar drawer, luego disparar ATC sin interceptar
    setTimeout(() => {
      closeDrawer();

      setTimeout(() => {
        const atcBtn = currentForm.querySelector('button[name="add"]');
        if (atcBtn) {
          skipIntercept = true; // desactivar intercepción
          atcBtn.click();
          setTimeout(() => { skipIntercept = false; }, 500);
        }

        // Volver a ocultar selector nativo
        optionBtns.forEach(el => el.style.cssText = 'display:none!important;');
      }, 200);
    }, 150);
  }

  function handleSoldOut(value) {
  closeDrawer();
  
  setTimeout(() => {
    // Buscar el botón de STOQ para esa talla
    const section = document.querySelector('.m-main-product, .main-product');
    if (!section) return;

    // Seleccionar la variante agotada primero
    const node = section.querySelector(`.m-product-option--node[data-value="${value}"]`);
    if (node) {
      const radio = node.querySelector('input[type="radio"]');
      const label = node.querySelector('label');
      if (radio) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (label) label.click();
    }

    // Esperar a que STOQ actualice y hacer click en su botón
    setTimeout(() => {
      const stoqBtn = document.querySelector('.restock-rocket-button-product');
      if (stoqBtn) {
        stoqBtn.click();
      }
    }, 300);
  }, 350);
}

  function hideNativeSizes() {
    if (document.getElementById('anbe-hide-sizes')) return;
    const style = document.createElement('style');
    style.id = 'anbe-hide-sizes';
    style.textContent = `
      .m-product-option--button { display: none !important; }
      .main-product__block-variant-picker .m-product-option--label { display: none !important; }
    `;
    document.head.appendChild(style);
  }

  function interceptATC() {
    hideNativeSizes();

    const forms = document.querySelectorAll('form[action*="/cart/add"]');
    forms.forEach(form => {
      const section = form.closest('[data-section-id]')
        || form.closest('.m-main-product')
        || document.querySelector('.main-product');
      if (!section) return;

      const hasSizes = section.querySelector('.m-product-option--node[data-option-type="button"]');
      if (!hasSizes) return;

      const btns = form.querySelectorAll('button[type="submit"], button[name="add"]');
      btns.forEach(btn => {
        if (btn.dataset.anbeOk) return;
        btn.dataset.anbeOk = '1';

        btn.addEventListener('click', function(e) {
          if (skipIntercept) return; // dejar pasar el click interno
          e.preventDefault();
          e.stopImmediatePropagation();
          openDrawer(form, section);
        }, true);
      });
    });
  }

  function init() {
    createDrawer();
    interceptATC();
    document.addEventListener('shopify:section:load', () => setTimeout(interceptATC, 400));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();